module.exports = __webpack_public_path__ + "img/group-icon.3c1022ee.svg";